// extracted by mini-css-extract-plugin
export default {"inputs-empty":"inputs-empty___dT5ON","inputs-container":"inputs-container___ejVcS","app-new-plugin-btn":"app-new-plugin-btn___FN408"};